import React from 'react';
import PropTypes from 'prop-types';
import { Grid, CircularProgress } from '@material-ui/core';

export default function DefaultSpinner({ classes, disableShrink }) {
    return (
        <Grid container justify="center" alignItems="center" className={classes.root}>
            <Grid item>
                <CircularProgress size={120} disableShrink={disableShrink} />
            </Grid>
        </Grid>
    );
}

DefaultSpinner.propTypes = {
    classes: PropTypes.shape({
        root: PropTypes.string,
    }).isRequired,
    disableShrink: PropTypes.bool,
};

DefaultSpinner.defaultProps = {
    disableShrink: false,
};
